import React, { useEffect, useState } from 'react';
import styles from './adcu-security-detail.module.scss';
import { useParams } from 'react-router';
import SecurityService from '../../../../services/security-service';
import { Security } from '../../../../models/security';
import SecurityDetailSection from "./components/security-detail-section/security-detail-section";
import SellingAgentSection from "./components/selling-agent-section/selling-agent-section";
import Loading from "../../../../components/loading/loading";

const ADCUSecurityDetail = () => {
  const { securityId } = useParams();
  const [ loading, setLoading] = useState(false);
  const [ security, setSecurity ] = useState({});
  const [ sellingAgents, setSellingAgents ] = useState([]);
  const securityService = new SecurityService();

  useEffect(()=>{
    const setSecurityDetails = async () => {
      setLoading(true);
      try {
        const securityDetail = await securityService.getSecurityDetail(securityId);
        setSecurity(new Security(securityDetail['security']));
        const sellingAgents = await securityService.getSecuritySellingAgents(securityId);
        setSellingAgents(sellingAgents);
      } catch(error){
        console.log(error.message);
      } finally {
        setLoading(false);
      }
    }
    setSecurityDetails();
  },[])

  return loading ? <Loading /> : (
    <div className={styles['adcu-security-detail']}>
      <SecurityDetailSection security={security} sellingAgents={sellingAgents}/>
      <SellingAgentSection security={security} sellingAgents={sellingAgents} />
    </div>
  )
}

export default ADCUSecurityDetail;

